// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-cancelled-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 0;
}

.warning-icon {
  font-size: 48px;
  height: 48px;
  width: 48px;
  color: var(--ion-color-warning);
  margin-bottom: 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}

p {
  font-size: 16px;
  line-height: 1.5;
  color: var(--ion-text-color);
}`, "",{"version":3,"sources":["webpack://./src/app/components/payment-cancelled-modal/payment-cancelled-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AACF","sourcesContent":[".payment-cancelled-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 20px 0;\n}\n\n.warning-icon {\n  font-size: 48px;\n  height: 48px;\n  width: 48px;\n  color: var(--ion-color-warning);\n  margin-bottom: 16px;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 24px;\n}\n\np {\n  font-size: 16px;\n  line-height: 1.5;\n  color: var(--ion-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
